import { render, staticRenderFns } from "./DarkFooter.vue?vue&type=template&id=e655bf16&scoped=true&"
import script from "./DarkFooter.vue?vue&type=script&lang=js&"
export * from "./DarkFooter.vue?vue&type=script&lang=js&"
import style0 from "./DarkFooter.vue?vue&type=style&index=0&id=e655bf16&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e655bf16",
  null
  
)

export default component.exports